module.exports = __webpack_public_path__ + "img/_54A6720.503cf956.jpg";